/* ============================================================
   Gold Perfumes — CAMPAÑA CYBER (piezas y reloj)

   El interruptor vive en el <head> del layout y solo pone una clase
   en el <html>. Acá se arman las piezas, que se IMPRIMEN SIEMPRE y
   las esconde gp-cyber.css: así, cuando el reloj da la hora, no hay
   que repintar nada ni recargar la página.
   ============================================================ */
(function () {
  'use strict';
  var C = (window.GP = window.GP || {}).cyber || {};
  var GP = window.GP;

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- reloj ---------- */
  function casillas() {
    return '<span class="cyb-reloj__c" data-u="d">--<i>días</i></span>' +
           '<span class="cyb-reloj__p">:</span>' +
           '<span class="cyb-reloj__c" data-u="h">--<i>hrs</i></span>' +
           '<span class="cyb-reloj__p">:</span>' +
           '<span class="cyb-reloj__c" data-u="m">--<i>min</i></span>' +
           '<span class="cyb-reloj__p">:</span>' +
           '<span class="cyb-reloj__c" data-u="s">--<i>seg</i></span>';
  }
  function reloj(rotulo, hasta) {
    return '<span class="cyb-reloj" data-hasta="' + hasta + '">' +
      (rotulo ? '<span class="cyb-reloj__r">' + esc(rotulo) + '</span>' : '') + casillas() + '</span>';
  }

  function tic() {
    var ahora = Date.now(), seguir = false;
    document.querySelectorAll('.cyb-reloj[data-hasta]').forEach(function (r) {
      var falta = (+r.getAttribute('data-hasta') || 0) - ahora;
      if (falta < 0) falta = 0; else seguir = true;
      var s = Math.floor(falta / 1000);
      var v = { d: Math.floor(s / 86400), h: Math.floor(s / 3600) % 24, m: Math.floor(s / 60) % 60, s: s % 60 };
      r.querySelectorAll('.cyb-reloj__c').forEach(function (c) {
        var u = c.getAttribute('data-u'), n = v[u];
        var txt = (u === 'd' ? String(n) : (n < 10 ? '0' : '') + n);
        if (c.firstChild && c.firstChild.nodeType === 3) {
          if (c.firstChild.nodeValue !== txt) c.firstChild.nodeValue = txt;
        } else { c.insertBefore(document.createTextNode(txt), c.firstChild); }
        /* "1 días" se lee mal: el rótulo va en singular cuando corresponde */
        if (u === 'd') { var r = c.querySelector('i'); if (r) r.textContent = n === 1 ? 'día' : 'días'; }
      });
      /* al llegar a cero el sitio se desviste solo */
      if (falta === 0 && typeof C.pintar === 'function') C.pintar();
    });
    return seguir;
  }

  /* ---------- barra superior ---------- */
  GP.cyberBarra = function () {
    if (!C.ini || !C.fin) return '';
    var col = '/collections/' + (C.coleccion || 'ofertas');
    var pct = (C.pct || '').toString().replace(/[^\d]/g, '');
    return '<div class="cyb cyb-bar"><div class="cyb-bar__in">' +
      '<span class="cyb-bar__marca">' + esc(C.nombre || 'Cyber Gold') + '</span>' +
      /* durante */
      '<span class="cyb-solo-on cyb-bar__txt">' +
        (pct ? '<b>Hasta −' + pct + '%</b> en todo el catálogo' : '<b>Precios de distribuidor</b> en todo el catálogo') +
      '</span>' +
      '<span class="cyb-solo-on">' + reloj('Termina en', C.fin) + '</span>' +
      '<a class="cyb-solo-on cyb-bar__cta" href="' + col + '">Ver la selección</a>' +
      /* antesala */
      '<span class="cyb-solo-pre cyb-bar__txt"><b>' + esc(C.preTit || 'Ya viene el Cyber') + '</b></span>' +
      '<span class="cyb-solo-pre">' + reloj('Empieza en', C.ini) + '</span>' +
    '</div></div>';
  };

  /* ---------- franja para categorías y ficha ---------- */
  GP.cyberFranja = function () {
    if (!C.ini || !C.fin) return '';
    var pct = (C.pct || '').toString().replace(/[^\d]/g, '');
    return '<div class="cyb cyb-franja">' +
      '<div><b>' + esc(C.nombre || 'Cyber Gold') + '</b> ' +
        '<span class="cyb-solo-on">' + (pct ? 'Hasta −' + pct + '% · ' : '') + 'precio rebajado marcado en cada perfume.</span>' +
        '<span class="cyb-solo-pre">' + esc(C.preTit || 'Ya viene') + '.</span></div>' +
      '<span class="cyb-solo-on">' + reloj('Termina en', C.fin) + '</span>' +
      '<span class="cyb-solo-pre">' + reloj('Empieza en', C.ini) + '</span>' +
    '</div>';
  };

  /* ---------- colocar la franja donde corresponda ---------- */
  function colocarFranja() {
    if (document.querySelector('.cyb-franja')) return;
    var html = GP.cyberFranja();
    if (!html) return;
    /* categorías y buscador: arriba de la barra de orden. Ficha: bajo la miga. */
    var destino = document.querySelector('.tbar');
    if (destino && destino.parentNode) {
      destino.insertAdjacentHTML('beforebegin', html); return;
    }
    var miga = document.querySelector('.miga');
    if (miga && miga.parentNode) miga.parentNode.insertAdjacentHTML('beforeend', html);
  }

  /* ---------- banner de portada ---------- */
  function pintarHero() {
    var caja = document.querySelector('[data-cyber-hero]');
    if (!caja || caja.getAttribute('data-listo') || !C.ini || !C.fin) return;
    caja.setAttribute('data-listo', '1');
    var col = '/collections/' + (C.coleccion || 'ofertas');
    var pct = (C.pct || '').toString().replace(/[^\d]/g, '');
    caja.innerHTML = '<div class="cyb-hero__in">' +
      '<div>' +
        '<span class="cyb-hero__sello"><span></span>' + esc(C.nombre || 'Cyber Gold') + '</span>' +
        '<h2 class="cyb-solo-on">' + esc(C.titular || '') + '</h2>' +
        '<h2 class="cyb-solo-pre">' + esc(C.preTit || '') + '</h2>' +
        (C.bajada ? '<p>' + esc(C.bajada) + '</p>' : '') +
        '<div class="cyb-hero__acc">' +
          '<a class="btn btn--oro cyb-solo-on" href="' + col + '">Ver la selección</a>' +
          '<a class="btn btn--linea" href="/collections/catalogo">Todo el catálogo</a>' +
        '</div>' +
      '</div>' +
      '<div class="cyb-hero__caja">' +
        (pct ? '<div class="cyb-hero__pct"><small>Hasta</small>&minus;' + pct + '%</div>' : '') +
        '<div class="cyb-solo-on">' + reloj('Termina en', C.fin) + '</div>' +
        '<div class="cyb-solo-pre">' + reloj('Empieza en', C.ini) + '</div>' +
        '<p class="cyb-hero__nota">El descuento ya viene aplicado en cada precio. Stock real en Providencia.</p>' +
      '</div>' +
    '</div>';
  }

  function arrancar() {
    pintarHero();
    colocarFranja();
    if (tic()) {
      clearInterval(arrancar._i);
      arrancar._i = setInterval(function () { if (!tic()) clearInterval(arrancar._i); }, 1000);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
  /* la cabecera la pinta gp.js después; cuando cambia el estado se vuelve a enganchar */
  document.addEventListener('gp:cyber', arrancar);
  window.addEventListener('load', arrancar);
})();
